import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Seo from "@/components/Seo";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { formatApiErrorDetail } from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const u = await login(email, password);
      navigate(u.role === "admin" ? "/admin" : "/account");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-5 py-24">
      <Seo title="Sign In" path="/login" noindex />
      <p className="font-mono-label text-xs text-primary mb-3">Welcome back</p>
      <h1 className="font-display text-4xl font-light mb-8">Sign in</h1>
      <form onSubmit={submit} className="space-y-5" data-testid="login-form">
        <div>
          <Label className="font-mono-label text-[11px]">Email</Label>
          <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" className="mt-2 h-11" />
        </div>
        <div>
          <Label className="font-mono-label text-[11px]">Password</Label>
          <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" className="mt-2 h-11" />
        </div>
        {error && <p className="text-destructive text-sm" data-testid="login-error">{error}</p>}
        <Button type="submit" disabled={loading} className="w-full h-11 rounded-full font-mono-label text-xs" data-testid="login-submit">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign In"}
        </Button>
      </form>
      <p className="text-sm text-muted-foreground mt-6 text-center">
        New here? <Link to="/register" className="text-primary hover:underline" data-testid="login-to-register">Create an account</Link>
      </p>
    </div>
  );
}
